import { ComponentClass, JSX, LazyExoticComponent, Suspense } from 'react';

import { Spinner } from 'library/components/controls/loaders/Spinner';
import { Area } from 'library/models/Area';
import Authorize from 'main/auth/Authorize';

type LazyRouteElementProps = {
	area?: Area;
	Component: LazyExoticComponent<
		ComponentClass<unknown, any> | (() => JSX.Element)
	>;
	path: string;
};

// Added to properly handle routes lazy loading using RRD v7
// Fix done based on https://github.com/remix-run/react-router/issues/12474#issuecomment-2538281149 - temp solution is to add a key to Suspense
const LazyRouteElement = ({ area, Component, path }: LazyRouteElementProps) => {
	const Element = (
		<Suspense fallback={<Spinner />} key={path}>
			<Component />
		</Suspense>
	);

	return <>{area ? <Authorize area={area}>{Element}</Authorize> : Element}</>;
};

export default LazyRouteElement;
